// https://scotch.io/tutorials/how-to-handle-file-uploads-in-vue-2#toc-file-upload-service
function upload(formData, formElementName) {
    const photos = formData.getAll(formElementName);
    const promises = photos.map((x) => getImage(x)
        .then(img => ({
            id: img,
            originalName: x.name,
            fileName: x.name,
            url: img
        })));
    return Promise.all(promises);
}

function getImage(file) {
    return new Promise((resolve, reject) => {
        const fReader = new FileReader();
        const img = document.createElement('img');

        fReader.onload = () => {
            img.src = fReader.result;
            resolve(img.src);
        };

        fReader.readAsDataURL(file);
    });
}

export { upload };
